import GoogleAd from "components/GoogleAd";

type AdSizes = {
  desktop?: googletag.GeneralSize;
  mobile?: googletag.GeneralSize;
};

type Props = {
  unit: string;
  className: string;
  sizes: AdSizes;
};

export default ({ unit, className, sizes }: Props) => (
  <GoogleAd
    adPath={`/13212770${unit}`}
    className={`leafly-gam-news-container leafly-gam-news-${className}`}
    sizes={sizes}
  />
);
